@if (!exporting) {
    @if (showButton) {
        <button class="btn btn-sm btn-secondary" (click)="export()" title="Export to Excel">
            <fa-icon [icon]="faDownload" [fixedWidth]="true"></fa-icon>
        </button>
    }
} @else {
    <button class="btn btn-sm btn-secondary" (click)="cancel()" title="Cancel Export">{{ progress }}</button>
}
